import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import DOMPurify from "isomorphic-dompurify";
import useWindowSize from "../../hooks/useWindowSize";
import { getApiUrl } from "../../utils/apiUrls";
import instance from "../../utils/axios";
import { useDispatch } from "react-redux";
import { openSnackBar } from "../../redux/actions/snackbar.actions";
import { apiErrorHandler } from "../../utils/errorHandler";
import { addPad } from "../../utils/helperFn";
import DocumentContent from "../../containers/task-dashboard/DocumentContent.container";
import { ReactComponent as EmptyData } from "../../assets/images/global/empty-data.svg";

function EventTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`eventtabpanel-${index}`}
      aria-labelledby={`event-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

const TaskModalBody = ({ t, instructionData, taskId, eventData, taskType, documentTaskCount,contentHeight }) => {
  const windowSize = useWindowSize();
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = React.useState(0);
  const [documentCount,setDocumentCount] = React.useState(0)
  const [documentData, setDocumentData] = React.useState(null);
  React.useEffect(() => {
    if (!!eventData?.eventId) {
      fetchData();
    }
  }, []);
  const fetchData = async () => {
    try {
      const res = await instance.get(
        `${getApiUrl("getDocumentDetailsForTaskAndEvent")}?eventId=${
          eventData.eventId
        }${!!taskId ? `&taskId=${taskId}&taskType=${taskType}` : ""}`
      );
      if (!!res.data) {
        setDocumentData(res.data);
        setDocumentCount(res?.data?.length > 0 ? res?.data?.length : 0);
      }
    } catch (error) {
      const msgObj = apiErrorHandler(error);
      dispatch(
        openSnackBar({
          msg: t(msgObj.statusText),
          type: "error",
        })
      );
    }
  };
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  return (
    <div>
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        className="cm-tasklist-tab-nav px-0"
      >
        <Tab
          label={t("instructions")}
          disableRipple
          className={`cm-tasklist-tab fw-medium cm-fs-14 ${
            windowSize.isMobile ? "text-capitalize" : ""
          }`}
        />
        <Tab
          label={t("document")}
          icon={
            <span className="cm-events-num text-white rounded-pill fw-medium cm-xs-txt cm-fs-12">
              {addPad(documentCount)}
            </span>
          }
          iconPosition="end"
          disableRipple
          className={`cm-tasklist-tab fw-medium ${
            windowSize.isMobile ? "text-capitalize" : ""
          }`}
        />
      </Tabs>
      <EventTabPanel
        value={tabValue}
        index={0}
        className="cm-sm-txt text-primary cm-tasklist-tab-content position-relative"
      >
        <div
          className={`cm-taskdetail-modal-content cm-sm-txt text-primary position-relative ${
            !!instructionData
              ? ""
              : "d-flex align-items-center justify-content-center"
          }`}
        >
          {!!instructionData ? (
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(instructionData),
              }}
            />
          ) : (
            <div className="d-flex align-items-center justify-content-center flex-column"  style={{
              height: !!contentHeight ? `${contentHeight}px` : "auto"
            }}>
              <EmptyData />
              <p className="my-0 text-blue-700 fw-semibold">
                {t("nothing_to_see")}
              </p>
            </div>
          )}
        </div>
      </EventTabPanel>
      <EventTabPanel
        value={tabValue}
        index={1}
        className="cm-sm-txt text-primary cm-tasklist-tab-content position-relative"
      >
        <DocumentContent t={t} taskId={taskId} taskType={taskType} eventId={eventData.eventId} contentHeight={contentHeight} documentData={documentData}/>
      </EventTabPanel>
    </div>
  );
};

export default TaskModalBody;
